(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    class CookieConsent extends HTMLElement {
    static STORAGE_KEY = 'cookie-consent-decision';

    connectedCallback() {
      this.acceptBtn = this.querySelector('[data-cookie-action="accept"]');
      this.rejectBtn = this.querySelector('[data-cookie-action="reject"]');

      this.acceptBtn?.addEventListener('click', () => this.decide(true));
      this.rejectBtn?.addEventListener('click', () => this.decide(false));

      // Re-open from any [data-cookie-settings] trigger anywhere on the page.
      this._reopenHandler = (e) => {
        const trigger = e.target.closest('[data-cookie-settings]');
        if (trigger) {
          e.preventDefault();
          this.hidden = false;
        }
      };
      document.addEventListener('click', this._reopenHandler);

      // Show only if no prior decision.
      if (!localStorage.getItem(CookieConsent.STORAGE_KEY)) {
        this.hidden = false;
      }
    }

    disconnectedCallback() {
      if (this._reopenHandler) {
        document.removeEventListener('click', this._reopenHandler);
      }
    }

    decide(accepted) {
      const consent = {
        analytics: accepted,
        marketing: accepted,
        preferences: accepted,
        sale_of_data: accepted,
      };

      const persist = () => {
        localStorage.setItem(CookieConsent.STORAGE_KEY, accepted ? 'accepted' : 'rejected');
        this.hidden = true;
      };

      this._whenPrivacyReady(2000).then((api) => {
        if (api) {
          try {
            api.setTrackingConsent(consent, persist);
            return;
          } catch (err) {
            console.warn('setTrackingConsent failed', err);
          }
        }
        // API unavailable — still record the local decision so we don't nag the user.
        persist();
      });
    }

    _whenPrivacyReady(timeoutMs) {
      return new Promise((resolve) => {
        if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
          resolve(window.Shopify.customerPrivacy);
          return;
        }
        const start = Date.now();
        const interval = setInterval(() => {
          if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
            clearInterval(interval);
            resolve(window.Shopify.customerPrivacy);
          } else if (Date.now() - start > timeoutMs) {
            clearInterval(interval);
            resolve(null);
          }
        }, 100);
      });
    }
  }

  if (!customElements.get('cookie-consent')) {
    customElements.define('cookie-consent', CookieConsent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    (function () {
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function bind(form) {
      if (form.dataset.newsletterBound) return;
      form.dataset.newsletterBound = '1';

      var emailInput = form.querySelector('input[type="email"]');
      var messageEl = form.querySelector('[data-newsletter-message]');
      var submitBtn = form.querySelector('button[type="submit"]');
      if (!emailInput || !messageEl) return;

      emailInput.addEventListener('input', function () {
        if (messageEl.dataset.state !== 'success' && messageEl.dataset.state !== 'error') {
          messageEl.hidden = true;
          messageEl.classList.remove('text-(--color-accent)');
        }
      });

      form.addEventListener('submit', function (e) {
        var value = emailInput.value.trim();
        if (!EMAIL_RE.test(value)) {
          e.preventDefault();
          messageEl.textContent = messageEl.dataset.invalid || 'Please enter a valid email address.';
          messageEl.classList.add('text-(--color-accent)');
          messageEl.hidden = false;
          return;
        }
        messageEl.textContent = messageEl.dataset.sending || 'Sending...';
        messageEl.classList.remove('text-(--color-accent)');
        messageEl.hidden = false;
        if (submitBtn) submitBtn.disabled = true;
      });
    }

    document.querySelectorAll('.newsletter-signup__form').forEach(bind);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-button"] && !Shopify.designMode) return;
  try {
    class ShareButton extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('.share-btn');
      if (!button) return;
      const label = button.querySelector('[data-share-label]');
      const title = button.dataset.shareTitle || document.title;

      button.addEventListener('click', async () => {
        const url = location.href;

        if (navigator.share) {
          try {
            await navigator.share({ title, url });
            return;
          } catch (e) {
            if (e && e.name === 'AbortError') return;
            // else fall through to clipboard
          }
        }

        try {
          await navigator.clipboard.writeText(url);
          if (label) {
            const original = label.textContent;
            label.textContent = 'Link copied';
            setTimeout(() => {
              label.textContent = original;
            }, 2000);
          }
        } catch (e) {
          console.warn('Share failed', e);
        }
      });
    }
  }

  if (!customElements.get('share-button')) {
    customElements.define('share-button', ShareButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-links"] && !Shopify.designMode) return;
  try {
    class ShareLinks extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('.share-links__copy');
      if (!button) return;

      const icon = button.querySelector('i');
      const status = button.querySelector('[role="status"]');
      const url = button.dataset.shareUrl || location.href;

      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(url);
        } catch (e) {
          console.warn('Copy link failed', e);
          return;
        }

        if (icon) icon.className = 'ph ph-check';
        if (status) status.textContent = 'Link copied';

        setTimeout(() => {
          if (icon) icon.className = 'ph ph-link';
          if (status) status.textContent = '';
        }, 2000);
      });
    }
  }

  if (!customElements.get('share-links')) {
    customElements.define('share-links', ShareLinks);
  }
  } catch(e) { console.error(e); }
})();

})();
